module.exports = __webpack_public_path__ + "static/adam-beyer-1b9d6057d95d530fef49431efb6dfde3.png";